export default __webpack_public_path__ + "static/media/energy-standard-chart.978e8ddc.png";